import {
  useEffect,
  useMemo,
  useState,
} from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

const isActiveStatus = (value) => {
  return (
    value === true ||
    Number(value) === 1
  );
};

export default function ModalSemesterAdd(props) {
  const token =
    localStorage.getItem("token");

  const id_user = localStorage
    .getItem("id_admin")
    ?.replace(
      /[|&;$%@"<>()+,]/g,
      ""
    );

  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false);

  const [
    getDataTA,
    setGetDataTA,
  ] = useState([]);

  const [form, setForm] = useState({
    ysb_academic_year_id: "",
    date_in: "",
    date_out: "",
    semester: "",
    status: 0,
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type":
          "application/json",
      },
    }),
    [token]
  );

  // =========================
  // GET TAHUN AJARAN
  // =========================
  useEffect(() => {
    const GetResponseTA =
      async () => {
        try {
          const response =
            await APIMS.get(
              "/api/academic-years?page=1&limit=1000&ascending=1&search=",
              fetchParams
            );

          setGetDataTA(
            response?.data?.data ||
              []
          );
        } catch (error) {
          ToastError.fire({
            icon: "error",
            title:
              error.response?.data
                ?.message ||
              "Gagal memuat data tahun ajaran",
          });
        }
      };

    GetResponseTA();
  }, [fetchParams]);

  const handleChange = (event) => {
    const { name, value } =
      event.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusToggle = (
    event
  ) => {
    setForm((prev) => ({
      ...prev,
      status:
        event.target.checked
          ? 1
          : 0,
    }));
  };

  const buildSemesterPayload = (
    row,
    status
  ) => ({
    ysb_academic_year_id:
      row?.ysb_academic_year_id,

    name_year:
      row?.name_year || "",

    date_in:
      row?.date_in || "",

    date_out:
      row?.date_out || "",

    semester: Number(
      row?.semester
    ),

    status: Number(status),

    user_id:
      id_user ||
      row?.user_id ||
      "",
  });

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = useMutation(
    async (event) => {
      event.preventDefault();

      if (
        form?.date_in &&
        form?.date_out &&
        form.date_out <
          form.date_in
      ) {
        ToastError.fire({
          icon: "error",
          title:
            "Tanggal akhir tidak boleh sebelum tanggal mulai",
        });

        return;
      }

      setIsSubmitting(true);

      const previousActiveRows = (
        props?.semesterData || []
      ).filter((item) =>
        isActiveStatus(
          item?.status
        )
      );

      let previousRowsWereDisabled =
        false;

      try {
        // Jika semester baru dibuat aktif,
        // nonaktifkan semester sebelumnya.
        if (
          Number(form?.status) ===
            1 &&
          previousActiveRows.length >
            0
        ) {
          await Promise.all(
            previousActiveRows.map(
              (item) =>
                APIMS.put(
                  `/api/semesters/${item?.id}`,
                  buildSemesterPayload(
                    item,
                    0
                  ),
                  fetchParams
                )
            )
          );

          previousRowsWereDisabled =
            true;
        }

        const response =
          await APIMS.post(
            "/api/semesters/store",
            {
              ysb_academic_year_id:
                form?.ysb_academic_year_id,

              date_in:
                form?.date_in,

              date_out:
                form?.date_out,

              semester: Number(
                form?.semester
              ),

              status: Number(
                form?.status
              ),

               user_id: id_user,
            },
            fetchParams
          );

        if (
          response?.status ===
            200 ||
          response?.status === 201
        ) {
          ToastSuccess.fire({
            icon: "success",
            title:
              response?.data
                ?.message ||
              "Data semester berhasil ditambahkan",
          });

          await props.GetResponseData();

          props.onHide();
        }
      } catch (error) {
        // Jika tambah gagal,
        // kembalikan semester aktif sebelumnya.
        if (
          previousRowsWereDisabled
        ) {
          try {
            await Promise.all(
              previousActiveRows.map(
                (item) =>
                  APIMS.put(
                    `/api/semesters/${item?.id}`,
                    buildSemesterPayload(
                      item,
                      1
                    ),
                    fetchParams
                  )
              )
            );
          } catch (
            rollbackError
          ) {
            console.error(
              "Gagal mengembalikan semester aktif sebelumnya:",
              rollbackError
            );
          }
        }

        ToastError.fire({
          icon: "error",
          title:
            error.response?.data
              ?.message ||
            "Gagal menyimpan data semester",
        });

        await props.GetResponseData();
      } finally {
        setIsSubmitting(false);
      }
    }
  );

  const statusActive =
    Number(form?.status) === 1;

  return (
    <Modal
      {...props}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Form
        onSubmit={(event) =>
          handleSubmit.mutate(
            event
          )
        }
      >
        <div className="sims-modal-header">
          <div>
            <h5 className="sims-modal-title">
              Tambah Semester
            </h5>
          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon
              icon={faXmark}
            />
          </button>
        </div>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-academic-year"
              >
                Tahun Ajaran
                <span>*</span>
              </label>

              <select
                id="add-academic-year"
                name="ysb_academic_year_id"
                className="sims-form-select"
                value={
                  form?.ysb_academic_year_id
                }
                onChange={
                  handleChange
                }
                required
              >
                <option
                  value=""
                  hidden
                >
                  Pilih Tahun Ajaran
                </option>

                {getDataTA.map(
                  (ta) => (
                    <option
                      key={ta?.id}
                      value={ta?.id}
                    >
                      {ta?.name_year}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-semester"
              >
                Semester
                <span>*</span>
              </label>

              <select
                id="add-semester"
                name="semester"
                className="sims-form-select"
                value={
                  form?.semester
                }
                onChange={
                  handleChange
                }
                required
              >
                <option
                  value=""
                  hidden
                >
                  Pilih Semester
                </option>

                <option value="1">
                  Semester 1
                </option>

                <option value="2">
                  Semester 2
                </option>
              </select>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-date-in"
              >
                Tanggal Mulai
                <span>*</span>
              </label>

              <input
                id="add-date-in"
                type="date"
                name="date_in"
                className="sims-form-input"
                value={
                  form?.date_in
                }
                onChange={
                  handleChange
                }
                onFocus={(
                  event
                ) =>
                  event.target.showPicker?.()
                }
                required
              />
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-date-out"
              >
                Tanggal Akhir
                <span>*</span>
              </label>

              <input
                id="add-date-out"
                type="date"
                name="date_out"
                className="sims-form-input"
                value={
                  form?.date_out
                }
                min={
                  form?.date_in ||
                  undefined
                }
                onChange={
                  handleChange
                }
                onFocus={(
                  event
                ) =>
                  event.target.showPicker?.()
                }
                required
              />
            </div>

            <div className="sims-form-span-2 sims-status-form-card">
              <div className="sims-status-form-info">
                <span className="sims-status-form-title">
                  Status Semester
                </span>

                <span className="sims-status-form-description">
                  Hanya satu semester
                  yang dapat aktif. Saat
                  semester ini
                  diaktifkan, semester
                  aktif sebelumnya
                  otomatis
                  dinonaktifkan.
                </span>
              </div>

              <div className="sims-status-form-action">
                <label className="sims-toggle">
                  <input
                    type="checkbox"
                    checked={
                      statusActive
                    }
                    onChange={
                      handleStatusToggle
                    }
                    aria-label="Aktifkan semester"
                  />

                  <span className="sims-toggle-slider" />
                </label>

                <span
                  className={`sims-status-label ${
                    statusActive
                      ? "is-active"
                      : "is-inactive"
                  }`}
                >
                  {statusActive
                    ? "Aktif"
                    : "Tidak Aktif"}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
           {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                <span>Tambahkan</span>
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}